import {
	Button,
	Card,
	Table,
	Typography,
	Skeleton,
	Flex,
	Col,
	Image,
	Empty,
} from "antd";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PrimaryButton from "./Buttons/PrimaryButton";
import CustomTable from "./Table/CustomTable";
const { Title, Paragraph } = Typography;

export default function RecentActivityTable({
	recentActivity,
	setProductToShowHistory,
	setIsModalOpen,
}) {
	const location = useLocation();
	const navigate = useNavigate();
	const isHistoryPage = location.pathname === "/history";
	const columns = [
		{
			title: "Image",
			dataIndex: "image",
			key: "image",
			width: "100px",
			render: (image) => (
				<Image
					src={image || ""}
					alt={"Product Image"}
					style={{ height: 50, objectFit: "cover" }}
					fallback="https://via.placeholder.com/200"
				/>
			),
		},
		{ title: "Product", width: "150px", dataIndex: "title", key: "title" },
		{
			title: "Date",
			dataIndex: "updatedAt",
			key: "updatedAt",
			render: (updatedAt) => new Date(updatedAt).toLocaleString(),
		},
		{
			title: "Current Description",
			key: "newDescription",
			dataIndex: "newDescription",
			render: (text) => (
				<Paragraph ellipsis={{ rows: 2 }}>
					{text || "No description available."}
				</Paragraph>
			),
		},
		{
			title: "Action",
			key: "action",
			width: "100px",
			render: (_, record) => (
				<PrimaryButton
				height={'30px'}
					onClick={() => {
						setProductToShowHistory(record);
						setIsModalOpen(true);
					}}
				>
					History
				</PrimaryButton>
			),
		},
	];

	const onGenerate = () => {
		navigate("/products");
	};

	return (
		<Card id="recent-activity">
			<Flex
				justify="space-between"
				align="center"
				wrap="wrap"
				style={{
					margin: "10px 0px",
				}}
			>
				<Title
					level={4}
					marginTop="0px"
					style={{
						margin: "0px",
					}}
				>
					🔥 Recent AI-Generated Descriptions
				</Title>

				{!isHistoryPage &&
					recentActivity?.length > 0 && ( // Show button only if NOT on history page
						<PrimaryButton onClick={() => navigate("/history")}>
							Show Full History
						</PrimaryButton>
					)}
			</Flex>

			{recentActivity ? (
				<Col
					span={24}
					style={{
						width: "100%",
						overflow: "hidden",
						overflowX: "auto",
					}}
				>
					{recentActivity?.length > 0 ? (
						<CustomTable
							columns={columns}
							data={recentActivity}
							
						/>
					) : (
						<NoDataComponent onGenerate={onGenerate} />
					)}
				</Col>
			) : (
				<Skeleton active paragraph={{ rows: 5 }} />
			)}
		</Card>
	);
}

const NoDataComponent = ({ onGenerate }) => (
	<div style={{ textAlign: "center", padding: "40px" }}>
		<Empty description={false} />
		<Paragraph style={{ color: "#666", fontSize: "14px", marginTop: "8px" }}>
			No AI-generated descriptions found. Click below to generate one for your
			products.
		</Paragraph>
		<Button
			type="primary"
			style={{
				background: "#6D5BBA",
				borderRadius: "8px",
				fontWeight: 500,
				marginTop: "12px",
			}}
			onClick={onGenerate}
		>
			+ Generate AI Description
		</Button>
	</div>
);
